module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-common-cost-type"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 large-6 columns"
  }, [_c('label', [_vm._v("Name"), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.body.name.toUpperCase()
    },
    on: {
      "input": function($event) {
        _vm.body.name = $event.target.value.toUpperCase()
      }
    }
  })])]), _c('div', {
    staticClass: "small-12 large-6 columns"
  }, [_c('label', [_vm._v("Description"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.description),
      expression: "body.description"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.body.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "description", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns text-right"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.formSubmit
    }
  }, [_vm._v("Create")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3feba85b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CreateCommonCostType.vue
// module id = 2442
// module chunks = 1